export const isTextOverflowing = (element: HTMLElement): boolean => {
  return element.scrollWidth > element.clientWidth;
};
